import { render, staticRenderFns } from "./DialogDeleteUser.vue?vue&type=template&id=3763733c"
import script from "./DialogDeleteUser.vue?vue&type=script&lang=js"
export * from "./DialogDeleteUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports